import { TYPE_MODAL, CONFIRM_COLOR, CONFIRM_ICONS } from '../modal-confirm-notification';

export const ALERT_ITEM = {
    typeModal: TYPE_MODAL.INVALID,
    title: 'Hay despachos sin productos a despachar',
    valueButton: 'Aceptar',
    color: CONFIRM_COLOR.WARN,
    icon: CONFIRM_ICONS.WARNING
  };
